import React from "react";
import SliderMain from "react-slick";
import { handleImageError } from 'base/Utility'
const SliderBrands = (props) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        className:'sliderclient',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (<>
        <section className={`section sliderLocation pb-5 mb-0 ${props.bgClass}`} >
            <div className="container">
                <div className="row">
                    <SliderMain {...settings}>
                        {
                            props.data && props.data.length > 0 ? props.data.map((client, index) => {
                                return client.file && client.file.fileUrl ?
                                    <div className="swiper-slide align-center justify-content-center d-flex">
                                        <img className="img-sliderClient resize-image" src={client.file.fileUrl} onError={handleImageError} />
                                    </div> : ""
                            }) : ""
                        }
                    </SliderMain>
                </div>
            </div>
        </section>
    </>)
}

export default SliderBrands;